{
    "account": "账户",
    "add_bookmark": "为消息添加书签",
    "add_date": "添加日期",
    "ago": "{{duration}}前",
    "api_key": "API密钥",
    "are_you_sure": "您确定吗?",
    "ask_delete_message": "删除此消息?",
    "audio_not_ready": "音频尚未准备好。",
    "bookmark_added": "消息已添加书签",
    "bookmark_removed": "消息中的书签已被移除",
    "bookmarks": "书签",
    "cancel_write": "是否确实要取消编写新消息?",
    "cancel": "取消",
    "changed_group_name": "更改了组的名称",
    "confirm_password_placeholder": "确认密码",
    "connect": "连接",
    "create_a_group": "创建群组",
    "create_the_group": "创建群组",
    "daily": "每天",
    "default_group": "默认群组",
    "delete": "删除",
    "destroy_account_explain": "一旦您删除了账户,您将无法撤销本操作! 请确认。",
    "destroy_account": "删除您的账户",
    "edit": "编辑",
    "email_input": "在这里输入您的电子邮件地址",
    "email": "电子邮箱",
    "empty_message": "无法发送空消息",
    "error_new_message": "发送消息时出错。",
    "error_upload": "上传出错",
    "error": "出错了",
    "forgot_password": "忘记你的密码了吗?",
    "group_left": "你离开了群组",
    "group_share_choice": "您想将此消息发送到哪个群组?",
    "groups": "组",
    "group_updated": "群组已更新",
    "has_commented_on": "评论于",
    "has_joined": "已加入",
    "has_left": "已退出",
    "has_posted_in": "已发布于",
    "hourly": "每小时",
    "Invalid login/password": "用户名或密码错误",
    "invitation_link": "邀请链接",
    "invitation_welcome": "欢迎来到Zusam ! 在加入一个组前,请先注册。",
    "in": "里",
    "just_now": "刚刚",
    "lang": "语言",
    "login_input": "选择一个以登录",
    "login_placeholder": "电子邮箱",
    "login": "登录",
    "logout": "注销",
    "mark_all_as_read": "全部已读",
    "monthly": "每月",
    "multiple_photos_upload": "发生错误。 请尝试逐个上传图像(在某些浏览器中可能会发生这种情况)。",
    "name_input": "选择一个名称",
    "name": "姓名",
    "new_password_placeholder": "新密码",
    "next_coms": "查看下一个评论",
    "none": "无",
    "notification_emails_stopped": "已停用邮件提醒!",
    "notification_emails": "电子邮件通知",
    "notifications": "通知",
    "parent_message": "父消息",
    "password_input": "在此输入您的的密码",
    "password_placeholder": "密码",
    "password_reset_mail_sent": "密码重置邮件已发送到您的电子邮箱收件箱",
    "passwords_dont_match": "密码不一致",
    "password": "密码",
    "previous_coms": "查看以前的评论",
    "public_link": "公共链接",
    "publish_in_group": "在群组里发布",
    "quit_group": "离开群组",
    "remove_bookmark": "为消息移除书签",
    "replies_one": "{{count}}回复",
    "replies_other": "{{count}}回复了",
    "reply": "回复",
    "reset_api_key": "重置API密钥(您将会断开连接)",
    "reset_invitation_link": "重设邀请链接",
    "reset_password_title": "重置您的密码",
    "save_changes": "保存更改",
    "search_in_group": "在此群组中搜索",
    "search_without_result": "没有匹配的消息。",
    "settings_updated": "你的设置已更新",
    "settings": "设置",
    "share_message": "分享此消息",
    "signup": "注册",
    "submit": "提交",
    "text_placeholder": "在这里输入您的消息",
    "the_message_from": "消息来自",
    "title_placeholder": "您消息的标题(可选)",
    "to": "到",
    "upload_audio": "添加音频文件。",
    "upload_image": "添加图片",
    "upload_music": "添加音乐",
    "upload_pdf": "添加PDF文件",
    "upload_video": "添加视频",
    "User not found": "用户不存在",
    "users": "用户",
    "video_not_ready": "视频尚未准备好。",
    "weekly": "每周"
}
